import {
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdOutlineTimer } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import Footer from "../../components/Footer.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getGoldApi } from "../../redux/features/goldSlice.js";
import { useFormik } from "formik";
import { sipSchema } from "../../utils/validationSchemas.js";
import {
  createSipApi,
  resetCreateSipState,
} from "../../redux/features/sip/createSipSlice.js";

import { FaCalendarAlt } from "react-icons/fa";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Timer from "../../components/Timer.jsx";
import { IoMdClose } from "react-icons/io";
import { decryptFields } from "../../utils/kycStatus.js";
import Loader from "../../components/Loader.jsx";
import CustomButton from "../../components/CustomButton.jsx";
import { getProfileApi } from "../../redux/features/profileSlice.js";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
};

export default function CustomGoldAndSilverSip() {
  const dispatch = useDispatch();
  const location = useLocation();
  const metalType = location.pathname.includes("gold") ? "Gold" : "Silver";

  const { amount: passedAmount } = location.state || {};

  const [activeAmount, setActiveAmount] = useState(null);

  const livePriceApiResponse = useSelector(
    (state) => state.goldSlice.data.data
  );

  const { gBuy, sBuy } = livePriceApiResponse?.[0]?.[0] || {};

  useEffect(() => {
    // dispatch(getGoldApi());
  }, [dispatch]);

  const {
    values,
    handleSubmit,
    handleChange,
    errors,
    touched,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: {
      date: "",
      amount: "",
      result: 0,
    },
    validationSchema: sipSchema,
    onSubmit: (values) => {
      if (values.amount < 100) {
        toast.error("Minimum purchase amount is ₹100");
        return;
      } else if (values.amount > 1000000) {
        toast.error("Maximum purchase amount is ₹1000000");
        return;
      } else {
        handleOpen2();
      }
    },
  });

  useEffect(() => {
    if (passedAmount) {
      let multipliedValue = 0;
      if (metalType === "Gold" && gBuy) {
        multipliedValue = Number(passedAmount) / gBuy;
      } else if (metalType === "Silver" && sBuy) {
        multipliedValue = Number(passedAmount) / sBuy;
      }

      setValues((prev) => ({
        ...prev,
        amount: passedAmount,
        result: multipliedValue,
      }));
    }
  }, [passedAmount, metalType, gBuy, sBuy, setValues]);

  const handleCreateSip = () => {
    const payload = {
      day_of_month: values.date || "",
      amount: values.amount || "",
      frequency: "monthly",
      metal_type: metalType.toLowerCase() || "gold",
    };
    dispatch(createSipApi(payload));
    handleClose2();
  };

  const handleAmountChange = (event) => {
    let value = event.target.value;

    // Allow only numbers and optional decimal
    const regex = /^\d*\.?\d*$/;

    if (regex.test(value) || value === "") {
      // Restrict max value
      if (parseFloat(value) > 1000000) {
        return;
      }

      // Restrict to 2 decimals
      if (value.includes(".")) {
        const [intPart, decPart] = value.split(".");
        if (decPart.length > 2) {
          return; // Prevent typing more than 2 decimals
        }
      }

      setFieldValue("amount", value);

      if (!isNaN(value) && value !== "") {
        let multipliedValue = 0;

        if (metalType === "Gold") {
          multipliedValue = Number(value) / gBuy;
        } else if (metalType === "Silver") {
          multipliedValue = Number(value) / sBuy;
        }

        setFieldValue("result", multipliedValue);
      } else {
        setFieldValue("result", 0);
      }
    }
  };

  // Add this useEffect to handle changes in metalType
  // useEffect(() => {
  //   setFieldValue("result", 0); // Reset result when metalType changes
  // }, [metalType, setFieldValue]);

  //   =================================================
  const formatDay = (day) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = day % 100;
    return `${day}${
      suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]
    } date of every month`;
  };

  // Handle day selection and set only the day number in Formik
  const handleDaySelect = (day) => {
    setSelectedDay(day);
    setFieldValue("date", day); // Store only the day number
    handleClose();
  };

  // Modal open/close state
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const createSipLoading = useSelector((state) => state.createSipSlice.status);

  const createSipResponse = useSelector(
    (state) => state.createSipSlice.data.data
  );

  useEffect(() => {
    if (createSipResponse?.data?.authLink) {
      window.location.href = createSipResponse?.data.authLink;
    }
    dispatch(resetCreateSipState());
  }, [createSipResponse?.data?.authLink]);

  const [selectedDay, setSelectedDay] = useState(null);

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const profileSliceResponse = useSelector(
    (state) => state?.profileSlice?.data?.data
  );

  // ===========================KYC STATUS====================

  const [userDetails, setUserDetails] = useState({
    pan: false,
    bank: false,
    address: false,
  });

  useEffect(() => {
    // Get the stored userDetails from localStorage
    const storedDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

    // Decrypt the userDetails fields
    const decryptedDetails = decryptFields(storedDetails, [
      "pan",
      "bank",
      "address",
    ]);

    // Set the decrypted values in the state
    setUserDetails({
      pan: decryptedDetails.pan || false,
      bank: decryptedDetails.bank || false,
      address: decryptedDetails.address || false,
    });
  }, [profileSliceResponse]);

  useEffect(() => {
    dispatch(getProfileApi());
  }, [dispatch]);

  return (
    <div className="universal_card">
      <div>
        <Modal
          open={open2}
          onClose={handleClose2}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h5"
                sx={{ textAlign: "center" }}
              >
                SIP Amount
              </Typography>
              <IoMdClose
                size={25}
                onClick={handleClose2}
                style={{ cursor: "pointer" }}
              />
            </Box>

            <div
              style={{
                backgroundColor: "#F3F2EE",
                display: "flex",
                justifyContent: "space-between",
                padding: "1rem",
                borderRadius: "0.5rem",
                margin: "1rem auto",
                color: "black",
              }}
            >
              <div style={{ fontWeight: "bold" }}>
                <div>SIP Amount</div>
                <div>Frequency</div>
                <div>Day Of Month</div>
              </div>
              <div>
                <div>:</div>
                <div>:</div>
                <div>:</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div>₹{values.amount}</div>
                <div>Monthly</div>
                <div>{formatDay(values.date)}</div>
              </div>
            </div>
            <p>
              <b>Note: </b>The first debit will occur today. Auto debit will
              begin next month.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              {/* <Button
                onClick={handleClose2}
                variant="outlined"
                sx={{
                  color: "#510d10",
                  borderColor: "#510d10",
                  "&:hover": {
                    color: "#510d10",
                    borderColor: "#510d10",
                  },
                }}
              >
                cancel
              </Button> */}

              <CustomButton
                label="CANCEL"
                onClick={handleClose2}
                outLined={true}
              />
              <CustomButton label="PAY" onClick={handleCreateSip} />
            </div>
          </Box>
        </Modal>
      </div>
      {createSipLoading === "loading" ? (
        <div style={{ height: "90vh" }}>
          <Loader />
        </div>
      ) : (
        <>
          <div className="inner-container">
            <div className="buySell_price_container">
              <div className="live-container">
                <span className="live-text">LIVE</span>
                <span className="live-dot"></span>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="medium-text">
                  {metalType === "Gold" ? (
                    <span
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "#EDBF00",
                      }}
                    >
                      ₹{gBuy}/gm <sup>+3% GST</sup>
                    </span>
                  ) : metalType === "Silver" ? (
                    <span
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "#A6A6A6",
                      }}
                    >
                      ₹{sBuy}/gm <sup>+3% GST</sup>
                    </span>
                  ) : (
                    <span>Invalid transaction type</span>
                  )}
                </div>
              </div>
              <div>
                {metalType === "Gold"
                  ? "24K 99.9% Pure Gold"
                  : "99.9% Pure Silver"}
              </div>
            </div>
            <div className="buySell_timer_container">
              <div>
                <img
                  src={
                    metalType === "Gold"
                      ? "/images/gold_shield.png"
                      : "/images/silver_shield.png"
                  }
                  alt={`${metalType}`}
                  width="20%"
                  height="auto"
                />
              </div>
              <div
                className="timer"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "5px",
                  // color: "#472878",
                }}
              >
                <MdOutlineTimer />
                <div>{metalType} rate expires in: </div>
                <Timer />
              </div>
            </div>
          </div>
          {/* ************************ */}
          <form
            onSubmit={handleSubmit}
            style={{ maxWidth: "840px", margin: "auto", paddingTop: "1rem" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
              }}
            >
              {/* ===============DATE================= */}
              <FormControl
                fullWidth
                // size="small"
                variant="outlined"
                error={touched.date && Boolean(errors.date)}
              >
                <InputLabel htmlFor="outlined-adornment-day">
                  Schedule Monthly SIP On
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-day"
                  value={values.date ? formatDay(values.date) : ""} // Format day for display
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle day selection"
                        edge="end"
                        onClick={handleOpen}
                      >
                        <FaCalendarAlt />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Schedule Monthly SIP On"
                  readOnly
                  onClick={handleOpen}
                />
                <div
                  style={{
                    color: "#d32f2f",
                    marginTop: "0.5rem",
                    fontSize: "14px",
                  }}
                >
                  {touched.date && errors.date ? errors.date : ""}
                </div>
              </FormControl>

              {/* +++++++++++++++MODAL++++++++++++++++++ */}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h5"
                      sx={{ marginBottom: "1rem" }}
                    >
                      Select Date for SIP
                    </Typography>
                    <IoMdClose
                      size={25}
                      onClick={handleClose}
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                      {Array.from({ length: 28 }, (_, index) => (
                        <Grid item xs={3} key={index}>
                          <Button
                            variant="outlined"
                            onClick={() => handleDaySelect(index + 1)}
                            fullWidth
                            sx={{
                              borderColor:
                                selectedDay === index + 1
                                  ? "#DA2128"
                                  : "#DA2128", // Active border color
                              color:
                                selectedDay === index + 1 ? "#fff" : "#DA2128", // Active text color
                              backgroundColor:
                                selectedDay === index + 1
                                  ? "#DA2128"
                                  : "transparent", // Active background color
                              "&:hover": {
                                borderColor: "#DA2128",
                                backgroundColor:
                                  selectedDay === index + 1
                                    ? "#DA2128"
                                    : "rgba(74, 42, 125, 0.1)",
                              },
                            }}
                          >
                            {index + 1}
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              </Modal>

              {/* ===============AMOUNT================= */}

              <FormControl
                fullWidth
                error={touched.amount && Boolean(errors.amount)}
              >
                <InputLabel htmlFor="outlined-adornment-amount">
                  Amount
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  name="amount"
                  startAdornment={
                    <InputAdornment position="start">₹</InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      {(values.result || 0).toFixed(3)} gm
                    </InputAdornment>
                  }
                  label="Amount"
                  value={values.amount}
                  onChange={handleAmountChange}
                />
                <div
                  style={{
                    color:
                      touched.amount && errors.amount ? "#d32f2f" : "inherit",
                    marginTop: "0.5rem",
                    fontSize: "14px",
                  }}
                >
                  {touched.amount && errors.amount
                    ? errors.amount
                    : "Minimum purchase of ₹100"}
                </div>
              </FormControl>
            </div>

            <div
              style={{
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "1rem",
              }}
            >
              Recommended:
            </div>

            <div className="button-container" style={{ gap: "0.5rem" }}>
              {["1000", "2000", "3000", "5000"].map((amount) => (
                <button
                  type="button"
                  className={`buttonBase ${
                    activeAmount === amount ? "buttonActive" : ""
                  }`}
                  key={amount}
                  onClick={() => {
                    setActiveAmount(amount);
                    setFieldValue("amount", amount);

                    // Update the result based on the selected amount
                    let multipliedValue = 0;

                    if (metalType === "Gold") {
                      multipliedValue = Number(amount) / gBuy;
                    } else if (metalType === "Silver") {
                      multipliedValue = Number(amount) / sBuy;
                    }

                    setFieldValue("result", multipliedValue);
                  }}
                >
                  ₹{amount}
                </button>
              ))}
            </div>

            {/* <QuickAmountButtons
          isRupeeSelected={true}
          activeAmount={activeAmount}
          handleAmountButtonClick={handleAmountButtonClick}
        /> */}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "1rem",
              }}
            >
              {userDetails.pan && userDetails.bank && userDetails.address ? (
                <div>
                  <CustomButton label="Proceed" type="submit" />
                </div>
              ) : (
                <Link to="/dashboard/profile/profileSetting">
                  <CustomButton label="Complete KYC" type="submit" />
                </Link>
              )}
            </div>
          </form>
          <Footer metalType={metalType} />
        </>
      )}
    </div>
  );
}
